import { select, fork, takeLatest, put, call } from 'redux-saga/effects';
import { getErrorMessageKey } from '../utils/helper';
import { INFOSERVICES } from '../actions/infoServices';
import { loadInfo } from './../utils/Api';

function* load({ page }) {
  try {
    const { text, error } = yield call(loadInfo, page);
    if (text) {
      yield put({ type: INFOSERVICES.LOAD_DONE, page, text });
    } else {
      const { translations } = yield select(({ i18n }) => i18n);
      const message = error && (getErrorMessageKey(translations, error.code) || error.msg);
      yield put({ type: INFOSERVICES.LOAD_FAILED, page, message: message || 'error loading info' });
    }
  } catch (message) {
    yield put({ type: INFOSERVICES.LOAD_FAILED, page, message });
  }
}

export default function* users() {
  yield [
    fork(function* () { yield takeLatest(INFOSERVICES.LOAD, load); }),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/infoServices.js